export default __webpack_public_path__ + "static/media/runner.be548dae.svg";